function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { z } from "zod";
export const operators = [
    "eq",
    "neq",
    "c",
    "gt",
    "gte",
    "lt",
    "lte",
    "t",
    "f",
    "null",
    "nnull"
];
export const operatorLabelLookup = {
    eq: "is",
    neq: "is not",
    c: "contains",
    gt: "greater than",
    gte: "greater than or equal to",
    lt: "less than",
    lte: "less than or equal to",
    t: "is true",
    f: "is false",
    null: "is null",
    nnull: "is not null"
};
export const callingObject = z.enum([
    "device",
    "user",
    "params",
    "computed"
]);
export const computedFunctions = z.enum([
    "minutesSince",
    "hoursSince",
    "daysSince"
]);
export const operatorOptions = operators.map((m)=>({
        value: m,
        label: operatorLabelLookup[m]
    }));
export const rhsValueOptions = [
    "string",
    "number",
    "boolean"
];
export const rhsValueLabelLookup = {
    string: "text",
    number: "number",
    boolean: "boolean"
};
export const rhsValueDropdownOptions = rhsValueOptions.map((m)=>({
        value: m,
        label: rhsValueLabelLookup[m]
    }));
const RHSNumberSchema = z.object({
    type: z.literal("number"),
    value: z.string().min(1)
});
const RHSStringSchema = z.object({
    type: z.literal("string"),
    value: z.string()
});
const RHSBooleanSchema = z.object({
    type: z.literal("boolean"),
    value: z.string()
});
export const ComputedFunctionSchema = z.object({
    type: z.literal("computed_function"),
    caller: callingObject,
    name: computedFunctions,
    args: z.string()
}).transform((data)=>_object_spread_props(_object_spread({}, data), {
        value: `$${data.caller}.$${data.name}(${data.args})`
    }));
const PropertySchema = z.object({
    type: z.literal("property"),
    value: z.string()
});
const ConditionSchema = z.object({
    lhs: z.union([
        ComputedFunctionSchema,
        PropertySchema
    ]),
    operator: z.enum(operators),
    rhs: z.union([
        RHSNumberSchema,
        RHSStringSchema,
        RHSBooleanSchema,
        ComputedFunctionSchema,
        PropertySchema
    ])
});
const RHSListSchema = z.object({
    type: z.literal("list"),
    value: z.array(ConditionSchema)
});
export const conditionOperators = [
    "and",
    "or"
];
export const entitlementOperators = [
    "not_contains",
    "empty"
];
// export const RuleEditorEntitlementNotContainsSchema = z.object({
//   type: z.literal("not_contains_all"),
//   operator: z.literal("not_contains_all"),
//   value: z.array(z.string()),
// })
export const RuleEditorSingleEntitlementStatusSchema = z.object({
    type: z.literal("entitlement_condition"),
    identifier: z.string(),
    status: z.enum([
        "active",
        "inactive"
    ])
});
export const RuleEditorEntitlementStatusSchema = z.object({
    type: z.literal("entitlement_conditions"),
    conditions: z.array(RuleEditorSingleEntitlementStatusSchema)
});
export const RuleEditorEntitlementEmptySchema = z.object({
    type: z.literal("no_active_entitlements")
});
export const RuleEditorEntitlementAllUsersSchema = z.object({
    type: z.literal("always_true")
});
export const RuleEditorEntitlementSchema = z.object({
    type: z.literal("entitlement"),
    rule: z.union([
        RuleEditorEntitlementEmptySchema,
        // RuleEditorEntitlementNotContainsSchema,
        RuleEditorEntitlementAllUsersSchema,
        RuleEditorEntitlementStatusSchema
    ])
});
export const RuleEditorSchema = z.object({
    operator: z.enum(conditionOperators),
    conditions: z.array(ConditionSchema),
    entitlements: RuleEditorEntitlementSchema.optional()
});
